<template>
  <div class="task-list">
    <div class="header">
      <div class="select">
        <mk-select
          v-model="activeIndex"
          class="select-item"
          width="120"
        >
          <mk-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-date-picker
          v-model="date"
          class="select-item"
          type="daterange"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
        <div class="btn-group">
          <mk-button-biz
            class="search-btn"
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz
            width="64px"
            class="reset-btn"
            @click="reset"
          >
            重置
          </mk-button-biz>
        </div>
      </div>
      <div>
        <mk-button-biz
          class="new-add-btn"
          type="primary"
          icon="el-icon-plus"
          @click="addNewTask"
        >
          创建任务
        </mk-button-biz>
      </div>
    </div>
    <div class="list">
      <mk-table
        :data="list"
        height="100%"
      >
        <mk-table-column
          prop="startTime"
          label="任务日期"
          width="100"
        />
        <mk-table-column
          prop="telephone"
          label="任务内容"
          min-width="300px"
        >
          <template v-slot="scope">
            <ul
              v-if="scope.row.formData"
              class="list-data"
            >
              <li
                v-for="(item,index) in scope.row.formData"
                :key="index"
                class="list-data-item"
              >
                分享文章
                <span style="color:#009cff;">《{{ item.title }}》</span>
              </li>
            </ul>
          </template>
        </mk-table-column>
        <mk-table-column
          label="任务状态"
          width="100"
        >
          <template v-slot="scope">
            <span :style="{color: scope.row.status === 2 ? 'rgb(56, 183, 56)' : ''}">
              {{ getTxt(scope.row.status) }}
            </span>
          </template>
        </mk-table-column>
        <mk-table-column
          label="销售完成情况"
          width="120"
        >
          <template v-slot="scope">
            <span>{{ scope.row.salesFinished }}/{{ scope.row.sales }}</span>
          </template>
        </mk-table-column>
        <mk-table-column
          label="操作"
          width="140"
          fixed="right"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              @click="detail(scope.row._id, scope.row.status)"
            >
              详情
            </mk-button-biz>
            <mk-button-biz
              v-if="scope.row.status === 1"
              type="text"
              @click="detail(scope.row._id, scope.row.status)"
            >
              编辑
            </mk-button-biz>
            <mk-button-biz
              v-if="scope.row.status === 1"
              type="text"
              @click="remove(scope.row)"
            >
              移除
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="handle-page">
      <!-- <div class="total-info">
        共{{ total }}条
      </div> -->
      <div class="page-info">
        <mk-pagination
          class="pagination"
          :current-page.sync="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </mk-pagination>
        <!-- <span class="page-tip">10条/页</span>
        <div class="jump">
          跳至
          <input
            v-model="nowPage"
            type="number"
            @keyup.enter="updatePage"
          />
          页
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { BIZAPIS } from '../../../api'
export default {
  data () {
    return {
      activeIndex: 0,
      options: [
        {
          label: '全部状态',
          value: 0
        },
        {
          label: '未开始',
          value: 1
        },
        {
          label: '进行中',
          value: 2
        },
        {
          label: '已结束',
          value: 3
        }
      ],
      title: '',
      list: [], // 列表数据
      page: 1, // 列表页数
      nowPage: 1,
      total: 0, // 列表总数
      visible: false,
      editStatus: false,
      saleInfo: {},
      editId: '',
      date: ''
    }
  },
  created () {
    // 销售
    this.getList()
  },
  methods: {
    getTxt (status) {
      let arr = ['未开始', '进行中', '已结束']
      return arr[status - 1]
    },
    updatePage (e) {
      if (Number(this.nowPage) < 1) {
        this.nowPage = 1
        this.page = 1
      } else {
        if (Math.ceil(this.total / 10) <= Number(this.nowPage)) {
          this.nowPage = Math.ceil(this.total / 10)
        }
      }
      this.page = Number(this.nowPage)
      this.getList()
    },
    handleCurrentChange (e) {
      this.nowPage = e
      this.page = e
      this.getList()
    },
    detail (id, status) {
      this.$router.push({
        path: '/spread-task/task-list/detail',
        query: {
          id: id,
          status: status
        }
      })
    },
    edit (data) {
      // 编辑
      this.editStatus = true
      this.visible = true
      this.editId = data._id
      this.saleInfo = {
        name: data.name,
        telephone: data.telephone,
        verifyCode: data.verifyCode
      }
    },
    success () {
      this.visible = false
      this.getList()
    },
    remove (data) {
      // 移除
      this.$confirm('移除后不可恢复，是否确认操作？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      })
        .then(() => {
          this.removeSale(data._id)
        })
        .catch(() => {})
    },
    async removeSale (id) {
      const res = await BIZAPIS.SpreadtaskApi.yqfSpreadtaskDeletePost({
        _id: id
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '移除成功',
          showClose: true
        })
        this.getList()
      }
    },
    cnacelRelation (data) {
      // 取消关联
      this.$confirm('取消微信关联后，该微信号不能再领取任务，是否确认操作？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      })
        .then(() => {
          this.cancelWxRelation(data._id)
        })
        .catch(() => {})
    },
    async cancelWxRelation (id) {
      const res = await BIZAPIS.SalesApi.yqfSalesManageUnbindGet({
        _id: id
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '解绑成功',
          showClose: true
        })
        this.page = 1
        this.getList()
      }
    },
    search () {
      this.page = 1
      this.nowPage = 1
      this.getList()
    },
    reset () {
      this.activeIndex = 0
      this.title = ''
      this.date = ''
    },
    async getList () {
      let metas = {
        page: this.page
      }
      if (this.activeIndex > 0) {
        metas['status'] = this.activeIndex
      } else {
        delete metas['status']
      }
      if (this.date instanceof Array && this.date.length === 2) {
        metas['startTime'] = dayjs(this.date[0]).format('YYYY-MM-DD')
        metas['endTime'] = dayjs(this.date[1]).format('YYYY-MM-DD')
      } else {
        delete metas['startTime']
        delete metas['endTime']
      }
      const res = await BIZAPIS.SpreadtaskApi.yqfSpreadtaskShowTaskGet(metas)
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    addNewTask () {
      this.$router.push({
        path: '/spread-task/task-list/add'
      })
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.task-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  /deep/.el-date-editor--daterange.el-input__inner {
    width: 260px;
    height: 32px;
  }

  /deep/ .el-range-separator {
    line-height: 24px;
  }

  /deep/ .el-range__icon {
    line-height: 24px;
  }

  /deep/ .el-range__close-icon {
    line-height: 24px;
  }

  /deep/ .el-icon-circle-close {
    line-height: 24px;
  }

  .header {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      display: flex;

      .select-item {
        margin-right: 10px;
      }

      /deep/ .search-btn {
        padding: 0 14px !important;
        border-radius: 4px;

        .el-icon-search {
          font-size: 14px;
        }

        span {
          font-size: 13px;
          margin-left: 4px;
        }
      }

      /deep/ .reset-btn {
        span {
          font-size: 13px;
        }
      }
    }

    .new-add-btn {
      margin-right: 10px;
    }

    /deep/ .new-add-btn {
      padding: 0 8px !important;
    }

    /deep/ .export-btn {
      padding: 0 11px !important;
    }
  }

  .list {
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    overflow: auto;

    .list-data {
      .list-data-item {
        font-size: 13px;
        line-height: 18px;
      }
    }
  }

  .handle-page {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 0 28px 0;

    .total-info {
      font-size: 13px;
      color: #6d7278;
      margin-left: 10px;
    }

    .page-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      // /deep/ .pagination {
      //   font-size: 13px;
      //   display: flex;
      //   align-items: center;
      //   margin-top: 0;

      //   .btn-prev {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-right: 6px solid #595959;

      //     .el-icon-arrow-left {
      //       display: none;
      //     }
      //   }

      //   .btn-prev:disabled {
      //     border-right: 6px solid #bfbfbf;
      //   }

      //   .btn-next {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-left: 6px solid #595959;

      //     .el-icon-arrow-right {
      //       display: none;
      //     }
      //   }

      //   .btn-next:disabled {
      //     border-left: 6px solid #bfbfbf;
      //   }

      //   .el-pager {
      //     margin: 0 8px;

      //     li {
      //       min-width: 30px;
      //       height: 24px;
      //       line-height: 24px;
      //     }
      //   }
      // }

      .page-tip {
        font-size: 14px;
        color: #595959;
        margin-left: -16px;
      }

      .jump {
        font-size: 13px;
        color: #595959;
        margin-left: 88px;

        input {
          width: 58px;
          height: 24px;
          padding: 0 12px;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
